export default __webpack_public_path__ + "static/media/hcpa-logo.839a97cb.png";